export default __webpack_public_path__ + "static/media/sword_website.367501e4.webp";